class BeamManager {

    static validateAndUpdate(project) {
        BeamManager.checkStability(project)
        BracingManager.sortAndCompactBraces(project)
        document.dispatchEvent(new CustomEvent('project-changed'))
    }

    // a bare bones model. we directly access the model to supress the
    // display of "Beam Modified, Save Now?" message
    // we pass in a boolean isLoggedIn allowing us to show new users a more
    // complex (engaging?) beam example. 
    static makeDefaultBeam(project, isLoggedIn) {
        project.beam.nodes.push(new NodeClass(0, "pinned"));
        project.beam.nodes.push(new NodeClass(144, "pinned"));
        if(!isLoggedIn) {
            project.beam.nodes.push(new NodeClass(288, "pinned"));
        }
        project.beam.nodes.sort( nodeSort );
        project.beam.rebuildSpans();
        project.beam.distLoads.push( new DistLoad( 0, 144, 1000/12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, false) );
        if(!isLoggedIn) {
            project.beam.pointLoads.push( new PointLoad(144 * 1.5, 1000, 0, 0, 0, 0, 0, 0, 0, false ) );
        }
        //sort distributed loads based on length
        project.beam.distLoads.sort( function(a, b){return a.Length() < b.Length(); } );
    }

    static makeNewSimpleBeam(project) {
        project.beam.nodes.push(new NodeClass(0, "pinned"))
        project.beam.nodes.push(new NodeClass(144, "pinned"))
        project.beam.nodes.sort( nodeSort )
        project.beam.rebuildSpans()
    }

    static cycleSupport(project, index) {
        //"free" -> "pinned" -> "fixed" ->
        if( index >= project.beam.nodes.length || index < 0 ) {
            return alert("Node index out of range.")
        }
        var support = project.beam.nodes[index].support
        if( support == "free" ) project.beam.nodes[index].support = "pinned"
        else if( support == "pinned" ) project.beam.nodes[index].support = "fixed"
        else if( support == "fixed" ) project.beam.nodes[index].support = "free"
        BeamManager.checkStability(project)
        document.dispatchEvent(new CustomEvent('project-changed'))
    }

    static checkStability(project) {
        //1. at least 1 fixed support
        //2. 1 pin and 1 roller
        //3. 2 pins
        //4. 2 pins
        var stable = false;
        var roller_or_pin_count = 0;
        for( var i = 0; i < project.beam.nodes.length; i++ )
        {
            if( project.beam.nodes[i].support == "fixed"){
                stable = true;
                break;
            }
            if( project.beam.nodes[i].support == "pinned" ||
            project.beam.nodes[i].support == "roller"){
                roller_or_pin_count++;
                if( roller_or_pin_count > 1 ){
                    stable = true;
                    break;
                }
            }
        }
        //update solve button...
        if( stable ){
            document.getElementById('design-this-beam-text').removeAttribute('disabled')
            document.getElementById('design-this-beam-text').innerHTML = ' Calculate'
            return true;
        } else {
            document.getElementById('design-this-beam-text').setAttribute('disabled', true)
            document.getElementById('design-this-beam-text').innerHTML = ' Beam is Not Stable - Add Another Support'
            return false;
        }
    }

    static addRightSpan(project, length) {
        if(customerLevel !== "pro" && project.beam.nodes.length > 2) {
            alert("Span limit for the free version is 2. Sign up to add more spans.");
            return false;
        }
    
        if( project.beam.nodes.length > 11 ) {
            alert( "Span limit is 10.");
            return false;
        }
        if( project.beam.TotalLength() + length > 500 * 12 ) {
            alert( "This beam is way too long!" );
            return false;
        }

        if(length <= 0.0) {
            alert( "Span length must be greater than 0." );
            return false;
        }
        
        //delete all "connection" braces
        var x = length + project.beam.TotalLength();
        project.beam.nodes.push( new NodeClass( x, "pinned") );
        project.beam.nodes.sort(nodeSort);
        project.beam.rebuildSpans();
        BeamManager.validateAndUpdate(project)
        return true
    }

    static addLeftSpan(project, length) {
        if(customerLevel !== "pro" && project.beam.nodes.length > 2) {
            alert("Span limit for the free version is 2. Sign up to add more spans.");
            return false;
        }
        if( project.beam.nodes.length > 11 ) {
            alert( "Span limit is 10.");
            return false;
        }
        if( project.beam.TotalLength() + length > 500*12 ) {
            alert( "This beam is way too long!" );
            return false;
        }

        if(length <= 0.0) {
            alert( "Span length must be greater than 0." );
            return false;
        }

        //delete all "connection" braces
        for( var i = 0 ; i < project.beam.nodes.length; i++ ) {
            project.beam.nodes[i].x += length;
        }
        project.beam.nodes.push( new NodeClass( 0, "pinned") );
        project.beam.nodes.sort(nodeSort);
        project.beam.rebuildSpans();
        BeamManager.validateAndUpdate(project)
        return true;
    }

    static modifySpan(project, index, length) {
        // get right node of this span and move it and all the following nodes
        const delta = length - project.beam.spans[index].length();
        const originalLength = project.beam.TotalLength();
        if( originalLength + length > 500*12 ) {
            alert( "This beam is way too long!" );
            return false;
        }
        // delete all "connection" braces
        for( var i = index+1; i < project.beam.nodes.length; i++ ) {
            project.beam.nodes[i].x += delta;
        }
        project.beam.nodes.sort(nodeSort)
        project.beam.rebuildSpans()
        LoadManager.validateLoads(project)
        BeamManager.validateAndUpdate(project)
        return true
    }

    static removeSpan(project, index) {
        if( project.beam.spans.length <= 1 ) return false
        //remove the node to the right of this span...
        if( project.beam.spans.length < index ) return false
        const delta = project.beam.spans[index].x2 - project.beam.spans[index].x1;
        const nodeIndex = index + 1
        if( nodeIndex >= project.beam.nodes.length ){
            alert( "node index out of range" );
            return false;
        }
        project.beam.nodes.splice(nodeIndex, 1);
        project.beam.nodes.sort(nodeSort);
        for( var i = nodeIndex; i < project.beam.nodes.length; i++ ) {
            project.beam.nodes[i].x -= delta;
        }
        project.beam.rebuildSpans();
        LoadManager.validateLoads(project)
        BeamManager.validateAndUpdate(project)
        return true
    }

    static updateNumberOfPlys(project, numberOfPlys) {
        if(numberOfPlys < 1) { 
            alert("Number of plys must be greater than 0."); 
            return false
        }
        project.numberOfPlys = numberOfPlys
        BeamManager.validateAndUpdate(project)
        return true
    }
}

class BracingManager {

    static validateAndUpdate(project) {
        BracingManager.sortAndCompactBraces(project)
        document.dispatchEvent(new CustomEvent('project-changed'))
    }

    static updateBracingType(project, bracingType) {
        project.design.bracingType = bracingType
        BracingManager.validateAndUpdate(project)
    }

    static addBrace(project, brace, isSupport) {
        if(brace > project.beam.TotalLength()) { return false }
        project.design.customBraces.push(new BeamBrace(brace, isSupport))
        BracingManager.validateAndUpdate(project)
        return true
    }

    static removeBrace(project, index) {
        if( index >= project.design.customBraces.length || index < 0 ) { return false }
        project.design.customBraces.splice(index,1)
        BracingManager.validateAndUpdate(project)
        return true
    }

    static addEquallySpacedBraces(project, spacing, startingAt) {
        if( spacing > project.beam.TotalLength() || spacing <= 0) { return false }
        if( startingAt > project.beam.TotalLength()) { return false }
        //check we're not adding more than about 50
        const nBraces = (parseFloat(project.beam.TotalLength()) - parseFloat(startingAt)) / parseFloat(spacing)
        if(nBraces > 50) { return false }
        project.design.bracingStartLocation = startingAt
        project.design.braceSpacing = spacing
        
        project.design.customBraces = []
        for( var i = 0; i <= nBraces; i++ ) {
            const loc = i * spacing + startingAt
            if( loc <= project.beam.TotalLength() ) {
                project.design.customBraces.push(new BeamBrace(loc, false))
            }
        }
        BracingManager.validateAndUpdate(project)
        return true
    }

    static sortAndCompactBraces(project) {
        BracingManager.sortAndRemoveDuplicateBraces(project)
        // reset all "support" braces - some may no longer fall on a node
        for(let j = 0; j < project.design.customBraces.length; j++) {
            project.design.customBraces[j].isSupport = false
        }

        // now check to see which braces fall on nodes
        for(let i = 0; i < project.beam.nodes.length; i++ ) {
            if(project.beam.nodes[i].support.match(/free/)) { continue }
            let exists = false
            for(let j = 0; j < project.design.customBraces.length; j++) {
                if(project.beam.nodes[i].x === project.design.customBraces[j].x) {
                    exists = true
                    project.design.customBraces[j].isSupport = true
                    break
                }
            }
            if(exists === false) {
                project.design.customBraces.push(new BeamBrace(project.beam.nodes[i].x, true))
            }
        }
        BracingManager.sortAndRemoveDuplicateBraces(project)
    }

    static sortAndRemoveDuplicateBraces(project) {
        if(project.design.customBraces.length < 2) { return } 
        // remove any braces that are beyond the length of the beam
        project.design.customBraces = project.design.customBraces.filter((brace) => brace.x <= project.beam.TotalLength())
        project.design.customBraces.sort(function(a, b){ return a.x - b.x })
        const braces = [];
        braces.push(project.design.customBraces[0])
        for (let i = 1; i < project.design.customBraces.length; i++) {
            if (project.design.customBraces[i - 1].x !== project.design.customBraces[i].x) {
                braces.push(new BeamBrace(project.design.customBraces[i].x, project.design.customBraces[i].isSupport))
            }
        }
        project.design.customBraces = []
        project.design.customBraces = braces;
    }
}

class LoadManager {

    static validateAndUpdate() {
        document.dispatchEvent(new CustomEvent('project-changed'))
    }

    static addPointLoad(project, x, D, L, Lr, S, W, E, H, R, isMoment) {
        if( project.beam.pointLoads.length > 20 ) {
            alert( "Load limit is 20.")
            return false
        }
        if( x > project.beam.TotalLength() ) { x = project.beam.TotalLength() }
        if( x < 0 ) { x = 0 }
        project.beam.pointLoads.push( new PointLoad(x, D, L, Lr, S, W, E, H, R, isMoment) )
        LoadManager.validateAndUpdate(project)
        return true
    }

    static modifyPointLoad(project, index, x, D, L, Lr, S, W, E, H, R) {
        if( index >= project.beam.pointLoads.length || index < 0 ) {
            alert("Point Load index out of range.")
            return false
        }
        if( x > project.beam.TotalLength() ) { x = project.beam.TotalLength() }
        if( x < 0 ) { x = 0 }
        project.beam.pointLoads[index].x = x
        project.beam.pointLoads[index].D = D
        project.beam.pointLoads[index].L = L
        project.beam.pointLoads[index].Lr = Lr
        project.beam.pointLoads[index].S = S
        project.beam.pointLoads[index].W = W
        project.beam.pointLoads[index].E = E
        project.beam.pointLoads[index].H = H
        project.beam.pointLoads[index].R = R
        LoadManager.validateAndUpdate(project)
        return true
    }

    static removePointLoad(project, index) {
        if(index >= project.beam.pointLoads.length || index < 0 ) {
            alert("Point Load index out of range.")
            return false 
        }
        project.beam.pointLoads.splice(index, 1)
        LoadManager.validateAndUpdate(project)
        return true
    }

    static addDistLoad(project, start, end, D, L, Lr, S, W, E, H, R, D2, L2, Lr2, S2, W2, E2, H2, R2, isLinear) {
        if( project.beam.distLoads.length > 10 ) {
            alert( "Distributed Load limit is 10.")
            return false
        }
        if(start > project.beam.TotalLength() || start < 0) {
            alert( "Distributed Load does not lie on beam.")
            return false
        }
        if(end > project.beam.TotalLength() || end < 0) {
            alert( "Distributed Load does not lie on beam.")
            return false
        }
        project.beam.distLoads.push( new DistLoad( start, end, D, L, Lr, S, W, E, H, R, D2, L2, Lr2, S2, W2, E2, H2, R2, isLinear) )
        //sort distributed loads based on length
        project.beam.distLoads.sort( function(a, b){return a.Length() < b.Length() } )
        LoadManager.validateAndUpdate(project)
        return true
    }

    static modifyDistLoad(project, index, start, end, D, L, Lr, S, W, E, H, R, D2, L2, Lr2, S2, W2, E2, H2, R2, isLinear) {
        if(index >= project.beam.distLoads.length || index < 0) {
            alert("Distributed Load index out of range.")
            return false
        }
        if(start > project.beam.TotalLength() || start < 0) {
            alert( "Distributed Load does not lie on beam.")
            return false
        }
        if(end > project.beam.TotalLength() || end < 0) {
            alert( "Distributed Load does not lie on beam.")
            return false
        }
        project.beam.distLoads[index].x1 = start;
        project.beam.distLoads[index].x2 = end;
        project.beam.distLoads[index].D = D;
        project.beam.distLoads[index].L = L;
        project.beam.distLoads[index].Lr = Lr;
        project.beam.distLoads[index].S = S;
        project.beam.distLoads[index].W = W;
        project.beam.distLoads[index].E = E;
        project.beam.distLoads[index].H = H;
        project.beam.distLoads[index].R = R;
        project.beam.distLoads[index].isLinear = isLinear;
        project.beam.distLoads[index].D2 = D2;
        project.beam.distLoads[index].L2 = L2;
        project.beam.distLoads[index].Lr2 = Lr2;
        project.beam.distLoads[index].S2 = S2;
        project.beam.distLoads[index].W2 = W2;
        project.beam.distLoads[index].E2 = E2;
        project.beam.distLoads[index].H2 = H2;
        project.beam.distLoads[index].R2 = R2;
        LoadManager.validateAndUpdate(project)
        return true
    }

    static removeDistLoad(project, index) {
        if( index >= project.beam.distLoads.length || index < 0 ) {
            alert("Distributed Load index out of range.")
            return false
        }
        project.beam.distLoads.splice(index, 1 );
        LoadManager.validateAndUpdate(project)
        return true
    }

    static validateLoads(project, delta) {
        //make sure loads are not off the edge of the beam
        var totalLength = project.beam.TotalLength()
        for(let i = 0; i < project.beam.pointLoads.length; i++) {
            if(project.beam.pointLoads[i].x < 0) { project.beam.pointLoads[i].x = 0 }
            if(project.beam.pointLoads[i].x > totalLength) { project.beam.pointLoads[i].x = totalLength }
        }
        for(let i = 0; i < project.beam.distLoads.length; i++) {
            if(project.beam.distLoads[i].x1 < 0) { project.beam.distLoads[i].x1 = 0 }
            if(project.beam.distLoads[i].x2 > totalLength) { project.beam.distLoads[i].x2 = totalLength }
        }
    }
}

function nodeSort(a, b){ return a.x - b.x; }

function hideResultDisplays() {
    document.getElementById("results-view-div").classList.add('d-none')
    document.getElementById("beam-reactions-div").classList.add('d-none')
    document.getElementById("design-summary-div").classList.add('d-none')
    document.getElementById("plots-div").classList.add('d-none')
    document.getElementById("numerical-results-div").classList.add('d-none')
    document.getElementById('api-error-panel').classList.add('d-none')
}
